import { FETCH_RESULTS, FETCH_RESULT, RESULTS_FILTER_SET, RESULTS_PAGE_SET } from '../../constants/Constants';

export const fetchResults = (pagination, filter, additionalQuery) => ({ type: FETCH_RESULTS.REQUESTED, payload: { pagination, filter, additionalQuery } });
export const fetchResult = (projectId, id, gameId) => ({
  type: FETCH_RESULT.REQUESTED,
  payload: { projectId, id, gameId }
});
export const setResultsFilter = filter => ({ type: RESULTS_FILTER_SET, payload: filter });
export const setResultsPage = page => ({ type: RESULTS_PAGE_SET, payload: { page } });



// WEBPACK FOOTER //
// ./src/actions/entities/ResultActions.js